<script>
    /*
    	ListHeaderCell.svelte

        7/28/22 - trying one common class instead of three

            CheckBox type
            Normal type (caption)
            Sortable type

        const cells = [
            {type: CELL_CHECKBOX, label: null, align: null, width: '5%', propName: null},
            {type: CELL_SORTABLE, label: 'Name', align: 'left', width: '25%', propName: 'service-name'},
            {type: CELL_SORTABLE, label: 'Distance', align: 'left', width: '10%', propName: 'service-distance'}
        ]
    */

    import { onMount } from 'svelte';

    // TCARE components

    // SMUI components
    import Checkbox from '@smui/checkbox';
    import { Icon } from '@smui/icon-button';
	import { Svg } from '@smui/common/elements';
	import { mdiArrowUpBold, mdiArrowDownBold, mdiMenuUp, mdiMenuDown } from '@mdi/js';


    export const CELL_CHECKBOX = 'cell-checkbox';
    export const CELL_STANDARD = 'cell-standard';
    export const CELL_SORTABLE = 'cell-sortable';
    export const CELL_DIVIDER  = 'cell-divider';
    
    export let type;                // cheating - which comp to generate - see below
    export let label;               // caption in Header
    export let propName;            // which field in the dataset
    export let onSort;              // external sort function for CELL_SORTABLE
    export let align;               // CSS text-align or justify-content
    export let style;               // other CSS - width, etc.
    export let onCheckboxClick;     // only for the CELL_CHECKBOX
    

    // const NORMAL_STYLE_1 = `color: var(--tcare-black); background-color: var(--menu-1); text-align: ${align}`;

    let isAscending = true;     // only used for SORTABLE cells

    onMount(() => {
    })

    const onSortIconClick = () => {
        isAscending = !isAscending;
        if (onSort) onSort(propName, isAscending);
    }

    const getAlignStyle = () => {
        if (align === '' || align === 'none') return '';
        return ` justify-content: ${align}; text-align: ${align}`;      // need the starting space!
    }


</script>

<style>

    .list-header-cell {
        user-select: none;
        font-size: 15px;
        color: var(--tcare-white);
        /* border: 1px solid red; */
    }

    
    .list-header-cell .checkbox-wrapper {
        display: flex;
        align-items: center;
        justify-content: center;
    }
    
    
    .list-header-cell .checkbox-bg {
        height: 18px;
        width: 18px;
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: white;
        border-radius: 50%;
    }
    

    .list-header-cell .icon-row {
        display: flex;
        align-items: center;
        justify-content: flex-start;
    }
    
    /* use up/down arrows here */
    .list-header-cell .sort-icon {
        width: 30px;
        margin-right: 5px;
        fill: var(--tcare-white);
    }

    :global(.list-header-cell .sort-icon svg) {
        outline: none;
    }

    /* convert checkboxes to circles */
    :global(.list-header-cell .mdc-checkbox__background) {
        border-radius: 50%;
    }

    .list-header-cell .cell-divider {
        width: 2px;
        height: 30px;
        background-color: #80488C;
        /* border-right: 1px solid #80488C; */
    }

    @media screen and (max-width: 600px) {
    }

    @media screen and (min-width: 601px) and (max-width: 1300px) {
    }

    @media screen and (min-width: 1201px) {
    }

</style>

<div class="list-header-cell" style={style + getAlignStyle()}>
    {#if type === CELL_CHECKBOX}
        <!-- render CELL_CHECKBOX -->
        <div class="checkbox-wrapper">
            <div class="checkbox-bg">
                <Checkbox on:click={onCheckboxClick} />
            </div>
        </div>
    {:else if type === CELL_SORTABLE}
        <div class="icon-row" style={getAlignStyle()}>
            <!-- render CELL_SORTABLE icons -->
            <div class="sort-icon flex-center" on:click={() => onSortIconClick()}>
                <Icon component={Svg} viewBox="0 0 24 24" >
                    {#if isAscending}
                        <path d={mdiMenuDown}/>
                    {:else}
                        <path d={mdiMenuUp}/>
                    {/if}
                </Icon>
            </div>
            {label}
        </div>
    {:else if type === CELL_DIVIDER}
        <div class="cell-divider"></div>
    {:else}
        <!-- render CELL_STANDARD -->
        {label}
    {/if}
</div>
